import { Page } from '@/core/architecture'

import { LotteryApplicationDetailPaymentConfirmationTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * LotteryApplicationDetailPaymentConfirmation Page
 * Implemented as a practical sample.
 */
export const LotteryApplicationDetailPaymentConfirmation: Page = () => {
  const { state, actions } = useViewModel()

  return (
    <LotteryApplicationDetailPaymentConfirmationTemplate
      state={state}
      {...actions}
    />
  )
}
